import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import {
  ConditionalRender,
  CustomizedTypography,
  VStack
} from '@components/Customized';
import { colorSet } from '@components/Provider';
import {
  useFetchMyQuotationUserQuery,
  CapaQuotationUserVerificationType,
  useFetchMyRefundBankAccountsQuery
} from '@generated/graphql';
import {
  IconButton,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { ChevronLeftOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { isBankAccountEditModeVar } from '@vars';
import { VerificationDialog } from '../Dialog/RequestActionDialog';
import { AccountAddForm } from './AccountAddForm';
import { RefundAccountList } from './RefundAccountList';

const BankAccount = () => {
  const { bankAccountNotice, banckAccountHeader } = useStyles();
  const {
    data: myQuotationUser,
    loading: myQuotationUserLoading
  } = useFetchMyQuotationUserQuery({
    fetchPolicy: 'cache-and-network'
  });
  const {
    data: myRefundBankAccounts,
    loading: myRefundBankAccountsLoading
  } = useFetchMyRefundBankAccountsQuery();
  const isEditMode = useReactiveVar(isBankAccountEditModeVar);

  const isNotVerifiedUser =
    myQuotationUser?.fetchMyQuotationUser.data?.verificationType !==
    CapaQuotationUserVerificationType.Verified;

  const hasAccount = !!myRefundBankAccounts?.fetchMyRefundBankAccounts.data
    ?.length;

  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const history = useHistory();

  const handleGoBack = () => {
    history.push('/mypage');
  };

  useEffect(() => {
    isBankAccountEditModeVar(!hasAccount);
  }, [hasAccount]);

  return (
    <>
      {matches && (
        <div className={banckAccountHeader}>
          <IconButton size="small" onClick={handleGoBack}>
            <ChevronLeftOutlined />
          </IconButton>
          계좌관리
        </div>
      )}
      <VStack gap={24} padding={matches ? '0 16px' : ''} margin={'0 0 56px 0'}>
        <CustomizedTypography fontWeight="500" variant="h2" gutterBottoms={12}>
          계좌 관리
        </CustomizedTypography>
        <div className={bankAccountNotice}>
          <CustomizedTypography>
            <b>꼭 확인해주세요!</b> 보다 안전한 캐파결제 서비스 제공을 위해 환불
            받으실 계좌를 등록해주세요. 환불금액을 수령할 환불계좌를 지정 할 때,
            고객으로 가입시 인증했던 실명과 예금주명이 일치해야함을 원칙으로
            합니다. 본인인증 정보와 상이한 경우 환불이 불가능하며 해당 조건에
            맞는 계좌 관련 서류 증빙이 완료될 때까지 환불금액의 송금을 보류할 수
            있습니다.
          </CustomizedTypography>
        </div>
        <ConditionalRender
          visible={!myQuotationUserLoading && !myRefundBankAccountsLoading}
        >
          {isEditMode ? <AccountAddForm /> : <RefundAccountList />}
        </ConditionalRender>
      </VStack>
      <VerificationDialog
        open={isNotVerifiedUser}
        onClose={handleGoBack}
        variant="account"
      />
    </>
  );
};

export default BankAccount;

const useStyles = makeStyles(
  (theme) => ({
    bankAccountNotice: {
      backgroundColor: colorSet.gray100,
      padding: 20,
      borderRadius: 12,
      marginBottom: 24
    },
    banckAccountHeader: {
      zIndex: 1010,
      height: 49,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'sticky',
      top: 0,
      padding: '12px 16px',
      borderBottom: `1px solid ${colorSet.gray400}`,
      backgroundColor: colorSet.gray000,
      marginBottom: 20,
      '& button': {
        position: 'absolute',
        left: 16,
        width: 24,
        height: 24
      }
    }
  }),
  { classNamePrefix: 'BankAccount-' }
);
